export const projects = [
  {
    title: "Algorithm Assisted Trading Application",
    subtitle: "Python, Machine Learning, Finance",
    description:
      "An application that tracks Exchange Traded Funds (ETFs) and identifies buy opportunities based on technical indicators and fundamental analysis strategies. Based on current holdings, the algorithm maintains an adaptative stop-loss strategy to limit exposure in loss scenarios.",
  },
  {
    title: "NFTs for Everyone",
    subtitle: "Node.js, Solidity, React",
    description:
      "A proof-of-concept webstore to allow users to purchase NFTs depicting historical figures.",
  },
  {
    title: "NYC Commute Assistant",
    subtitle: "Python, RaspberryPI",
    description:
      "A tool that obtains real-time data (GTFS-rt) from the NYC-MTA and determines the optimal departure times to ensure on-time arrival at the users preferred train station. The tool is designed to be run on a RaspberryPi as part of a connected home.",
    image: "./project-3.gif",
  },
  {
    title: "MP3 Conversion Service",
    subtitle: "Python, Kubernetes, Docker, RabbitMQ",
    description:
    "A system that consists of three microservices that allow users to upload videos to be processed into mp3 files. The system leverages Rabbit-MQ for asynchronous communication between the authentication service, converter service, and notification service all running in Kubernetes.",    image: "./project-4.gif",
  },
];

export const skills = [
  "Python",
  "Java",
  "React",
  "Next.js",
  "Node",
  "JavaScript",
  "Docker", 
  "Kubernetes",
  "Google Cloud Platform",
  "Amazon Web Services",
];



// WEBPACK FOOTER //
// ./src/data.js